@if (order) {
<rask-page [pageTitle]="order.kund.namn">
    <ng-container header>
        <rask-action-button
            (click)="removeClick('KUNDORDER_DETAIL_DELETE_PROMPT_HEADER','KUNDORDER_DETAIL_DELETE_PROMPT_TEXT','kundorder')"
            icon="far fa-trash-alt" aid="buttonRemove" [disabled]="!canEdit()">
            {{'DEFAULT_TA_BORT' | translate}}</rask-action-button>
        <rask-action-button [disabled]="!canEdit()" (click)="addOrderrad()" icon="fas fa-plus" aid="buttonAddOrderrad">
            {{'KUNDORDER_DETAIL_LAGG_TILL' | translate}}</rask-action-button>
        <rask-action-button (click)="copy()" [disabled]="!canEdit()" icon="fas fa-plus" aid="buttonCopyKundorder">
            Kopiera kundorder</rask-action-button>
        <rask-action-button (click)="viewLog()" icon="fas fa-history" aid="buttonViewLog">
            {{'KUNDORDER_DETAIL_VISA_LOGG' | translate}}</rask-action-button>
    </ng-container>
    <ng-container headerContent>
        <rask-order-header [orderDetail]="order"></rask-order-header>
    </ng-container>
    <rask-toggle-list>
        <ng-container list-header>
            <rask-label size="2">{{'KUNDORDER_DETAIL_MOTTAGNINGSPLATS' | translate}}</rask-label>
            <rask-label>{{'KUNDORDER_DETAIL_AVLASTNINGSPLATS' | translate}}</rask-label>
            <rask-label size="2">{{'KUNDORDER_DETAIL_HANDELSSORTIMENT' | translate}}</rask-label>
            <rask-label style="width:160px;max-width:none;">{{'KUNDORDER_DETAIL_KVANTITET' | translate}}</rask-label>
            <rask-label style="width:160px;max-width:none;">{{'KUNDORDER_DETAIL_FROM' | translate}}</rask-label>
            <rask-label style="width:160px;max-width:none;">{{'KUNDORDER_DETAIL_TOM' | translate}}</rask-label>
            <rask-label>{{'KUNDORDER_DETAIL_BALANS' | translate}}</rask-label>
        </ng-container>
        @for (kundorderrad of order?.kundorderrader; track kundorderrad) {
        <rask-toggle-list-item
            [locked]="kundorderrad.id === 0"
          [expanded]="order.kundorderrader.length === 1">
            <ng-container item-header>
                <rask-kundorderrad-edit
                    [kundorderTyp]="kundorderTyp"
                    [mattslag]="order.mattslag"
                    [rootForm]="rootForm"
                    [kundorder]="order"
                    (onRemove)="removeKundorderrad(kundorderrad)"
                    [showLabels]="false"
                    [kundorderrad]="kundorderrad">
                </rask-kundorderrad-edit>
            </ng-container>
            <ng-template>
                @if (kundorderrad.id > 0) {
                <rask-kundorderrad-details
                    [canEdit]="canEdit()"
                    [kundorderrad]="kundorderrad"
                    [kundorder]="order">
                </rask-kundorderrad-details>
                }
            </ng-template>
        </rask-toggle-list-item>
        }
    </rask-toggle-list>
    <ng-container footerContent>
        <rask-button aid="buttonAngra" color="tertiary" (click)="undo()" [disabled]="!commandService.isDirty()">
            {{ 'KUNDORDER_UNDO_ORDER' | translate }}</rask-button>
        <rask-save-button (click)="save()" [disabled]="!canSave()"></rask-save-button>
    </ng-container>
</rask-page>
}